import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ifc-workbench" }
const _hoisted_2 = { class: "ifc-workbench__toolbar" }
const _hoisted_3 = { class: "ifc-workbench__viewport-column" }
const _hoisted_4 = { class: "ifc-dock__body ifc-dock__body--props" }

import { ref } from 'vue';

    /**
     * Shared layout for any IFC page: top toolbar, collapsible left tree dock,
     * centre viewport (filled by the consumer mounting an IfcViewerCore on the
     * exposed <c>viewportEl</c>), collapsible right properties dock.
     *
     * The consumer fills the slots (toolbar, tree, properties) and reads
     * <c>viewportEl</c> via defineExpose for renderer mounting.
     *
     * Theme is light to match the surrounding Spheeres app.
     */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'IfcWorkbench',
  props: {
    height: {}
  },
  setup(__props: any, { expose: __expose }) {

    

    const viewportEl = ref<HTMLDivElement | null>(null);
    const treeCollapsed = ref(false);
    const propsCollapsed = ref(false);

    function onTreeWheel(event: WheelEvent) {
        const pane = event.currentTarget as HTMLElement | null;
        if (!pane) return;

        const maxScrollTop = pane.scrollHeight - pane.clientHeight;
        if (maxScrollTop <= 0 || event.deltaY === 0) return;

        let deltaY = event.deltaY;
        if (event.deltaMode === 1) deltaY *= 16;
        else if (event.deltaMode === 2) deltaY *= pane.clientHeight;

        const nextScrollTop = Math.max(0, Math.min(maxScrollTop, pane.scrollTop + deltaY));
        if (nextScrollTop === pane.scrollTop) return;

        pane.scrollTop = nextScrollTop;
        event.preventDefault();
        event.stopPropagation();
    }

    __expose({ viewportEl });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Top toolbar — page-specific actions go here. "),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "toolbar")
    ]),
    _createCommentVNode(" Three-column work area: tree dock + viewport + properties dock. "),
    _createElementVNode("div", {
      class: "ifc-workbench__main",
      style: _normalizeStyle(
                __props.height === 'auto'
                    ? { flex: '1 1 auto', minHeight: 0 }
                    : { height: (__props.height ?? 800) + 'px' }
            )
    }, [
      _createCommentVNode(" Tree dock (left) "),
      _createElementVNode("div", {
        class: _normalizeClass(["ifc-dock ifc-dock--left", { 'ifc-dock--collapsed': treeCollapsed.value }])
      }, [
        _createElementVNode("div", {
          class: "ifc-dock__header",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (treeCollapsed.value = !treeCollapsed.value))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["fa ifc-dock__chevron", treeCollapsed.value ? 'fa-chevron-right' : 'fa-chevron-left'])
          }, null, 2 /* CLASS */)
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "ifc-dock__body ifc-dock__body--tree",
          onWheel: onTreeWheel
        }, [
          _renderSlot(_ctx.$slots, "tree")
        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vShow, !treeCollapsed.value]
        ])
      ], 2 /* CLASS */),
      _createCommentVNode(" Viewport column (consumer mounts the renderer on viewportEl) "),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "viewport-extras"),
        _createElementVNode("div", {
          ref_key: "viewportEl",
          ref: viewportEl,
          class: "ifc-workbench__viewport"
        }, null, 512 /* NEED_PATCH */),
        _renderSlot(_ctx.$slots, "viewport-overlay")
      ]),
      _createCommentVNode(" Properties dock (right) "),
      _createElementVNode("div", {
        class: _normalizeClass(["ifc-dock ifc-dock--right", { 'ifc-dock--collapsed': propsCollapsed.value }])
      }, [
        _createElementVNode("div", {
          class: "ifc-dock__header",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (propsCollapsed.value = !propsCollapsed.value))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["fa", propsCollapsed.value ? 'fa-chevron-left' : 'fa-chevron-right'])
          }, null, 2 /* CLASS */),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ifc-dock__title" }, "Properties", -1 /* CACHED */))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "properties")
        ], 512 /* NEED_PATCH */), [
          [_vShow, !propsCollapsed.value]
        ])
      ], 2 /* CLASS */)
    ], 4 /* STYLE */)
  ]))
}
}

})